import { Headers } from '@egw/components'
import { type FeatureFlags } from '@egw/constants'
import { useFlags } from '@egw/feature-flags'
import { InvestmentsAccountRedesignPage } from '@egw/features-investment'
import { useTranslation } from '@egw/i18n'
import { Layout } from '@egw/layouts'
import { type FC } from 'react'

export const InvestmentsAccountPage: FC = () => {
  const { t } = useTranslation()

  const { flags } = useFlags<FeatureFlags>()

  return (
    <Layout>
      <Headers title={t('pages.investments.title')} />
      <InvestmentsAccountRedesignPage />
    </Layout>
  )
}
